import { render, staticRenderFns } from "./echo.vue?vue&type=template&id=45125702&scoped=true&"
import script from "./echo.vue?vue&type=script&lang=js&"
export * from "./echo.vue?vue&type=script&lang=js&"
import style0 from "./echo.vue?vue&type=style&index=0&id=45125702&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45125702",
  null
  
)

export default component.exports